module.exports = __webpack_public_path__ + "assets/400_500_visual-a1072b.svg";